export const EmbeddedCustomerTypes = {
  BUSINESS: 'business',
  INDIVIDUAL: 'individual',
} as const

export const EmbeddedCustomerStatuses = {
  AGREEMENTS_ACCEPTED: 'agreementsAccepted',
  KYB_PENDING: 'kybPending',
  ACTION_REQUIRED: 'actionRequired',
} as const

export const EmbeddedCustomerAgreementStatuses = {
  PENDING: 'PENDING',
  SIGNED: 'SIGNED',
  DECLINED: 'DECLINED',
} as const
